<template>
    <b-container class="help-page">
        <h2>Help</h2>
        <hr>

        <h4>
            Documentation for download
        </h4>

        <h5>
            <small class="text-muted">
                Click a document to view or download
            </small>
        </h5>
        <h5>
            <small class="text-muted">
                To report an issue anywhere on the site, send an email to
                <b-link href="mailto:brinda.berry@adhe.edu" class="link-item">Brinda Berry</b-link>
            </small>
        </h5>

        <b-card header="Local Applications">
            <b-list-group>
                <b-list-group-item>
                    Part One (Section 134)
                    <b-link
                        class="link-item ml-2"
                        target="_blank"
                        href="https://www.adheperkins.com/resources/Videos/Local_Application_Section_134.mp4"
                    >
                        (video)
                    </b-link>
                    <b-link
                        class="link-item ml-2"
                        target="_blank"
                        :href="baseUrl + '/Local_Application_Section_134.pdf'"
                    >
                        (pdf)
                    </b-link>
                </b-list-group-item>
                <b-list-group-item>
                    Part Two (Section 135) - Local Use Funds
                    <b-link
                        class="link-item ml-2"
                        target="_blank"
                        href="https://www.adheperkins.com/resources/Videos/Local_Application_Section_135.mp4"
                    >
                        (video)
                    </b-link>
                    <b-link
                        class="link-item ml-2"
                        target="_blank"
                        :href="baseUrl + '/Local_Application_Section_135_Local_Use_Funds.pdf'"
                    >
                        (pdf)
                    </b-link>
                </b-list-group-item>
                <b-list-group-item>
                    Part Three (Section 113) - Accountability
                    <b-link
                        class="link-item ml-2"
                        target="_blank"
                        href="https://www.adheperkins.com/resources/Videos/Local_Application_Section_113.mp4"
                    >
                        (video)
                    </b-link>
                    <b-link
                        class="link-item ml-2"
                        target="_blank"
                        :href="baseUrl + '/Local_Application_Section_113_Accountability.pdf'"
                    >
                        (pdf)
                    </b-link>
                </b-list-group-item>
            </b-list-group>
        </b-card>

        <b-card header="Annual Plans">
            <b-list-group>
                <b-list-group-item
                    class="link-item"
                    target="_blank"
                    :href="baseUrl + '/annual_plan_sequence.pdf'"
                >
                    Sequence
                </b-list-group-item>
                <b-list-group-item
                    class="link-item"
                    target="_blank"
                    :href="baseUrl + '/annual_plan_new_activity.pdf'"
                >
                    New Activity
                </b-list-group-item>
            </b-list-group>
        </b-card>

        <b-card header="Budgets">
            <b-list-group>
                <b-list-group-item
                    class="link-item"
                    target="_blank"
                    :href="baseUrl + '/budget_category_descriptions_for_ARC.pdf'"
                >
                    Budget category descriptions
                </b-list-group-item>
                <b-list-group-item
                    class="link-item"
                    target="_blank"
                    :href="baseUrl + '/reimbursement_for_sales_tax_and_rebates.pdf'"
                >
                    Reimbursement for Sales Tax and Rebates
                </b-list-group-item>
            </b-list-group>
        </b-card>

        <b-card header="Purchases">
            <b-list-group>
                <b-list-group-item
                    class="link-item"
                    target="_blank"
                    :href="baseUrl + '/creating_a_purchase_for_reimbursement.pdf'"
                >
                    Create a purchase for reimbursement
                </b-list-group-item>
            </b-list-group>
        </b-card>

        <b-card header="Inventory">
            <b-list-group>
                <b-list-group-item
                    class="link-item"
                    target="_blank"
                    :href="baseUrl + '/Inventory.pdf'"
                >
                    Inventory
                </b-list-group-item>
            </b-list-group>
        </b-card>

        <b-card header="Payments">
            <b-list-group>
                <b-list-group-item
                    class="link-item"
                    target="_blank"
                    :href="baseUrl + '/Payments.pdf'"
                >
                    Payments
                </b-list-group-item>
            </b-list-group>
        </b-card>

        <b-card header="EYPR Narrative">
            <b-list-group>
                <b-list-group-item
                    class="link-item"
                    target="_blank"
                    :href="baseUrl + '/End_of_Year_Program_Report_Narrative.pdf'"
                >
                    EYPR Narrative
                </b-list-group-item>
            </b-list-group>
        </b-card>

        <b-card header="EYPR Data">
            <b-list-group>
                <b-list-group-item
                    class="link-item"
                    target="_blank"
                    :href="baseUrl + '/End_of_Year_Program_Report_Data_Performance.pdf'"
                >
                    EYPR Data
                </b-list-group-item>
            </b-list-group>
        </b-card>

        <b-card header="Reports">
            <b-list-group>
                <b-list-group-item
                    class="link-item"
                    target="_blank"
                    :href="baseUrl + '/Reports.pdf'"
                >
                    Reports
                </b-list-group-item>
            </b-list-group>
        </b-card>
    </b-container>
</template>

<script>

export default {
    name: 'Help',

    metaInfo() {
        return { title: 'Help' };
    },

    data() {
        return {
        };
    },

    computed: {
        baseUrl() {
            // handle the difference between local dev and AWS setup
            return process.env.VUE_APP_ENV === 'development'
                ? process.env.VUE_APP_API_URL + '../../downloads'
                : process.env.VUE_APP_API_URL + '../downloads';
        },
    },

    methods: {
    },
};
</script>

<style scoped>

.help-page {
    text-align: left;
}
.card-header {
    font-weight: bold;
}
.link-item {
    text-decoration: underline;
    color: #005282;
}
</style>
